const clientId = 'W9EwYSv01ufd8JKwxcFdS5';
const clientSecret = 'EfzEHiw4pEfritCI9yeCM0e6uztEsf8YKxnpoZ3xFHD';
const redirectURL = 'https://seaseeker.eappsoft.net/wms/dashboard/notify';

export default { clientId, clientSecret, redirectURL };
